import { type App } from 'vue'
import { useApiErrorStore } from '@gat-ship/lib/error-handling'
import { AppError, ApiResponseError } from '@gat-ship/lib/error-handling'
import { handleApiError } from './api-error-handler'

export function handleGlobalErrors(app: App) {
  app.config.errorHandler = (err, vm, info) => {
    console.log('err', err)
    const errorStore = useApiErrorStore()
    if (err instanceof AppError) {
      console.log('iss app error', err)
      errorStore.newAppError(err)
    }
    if (err instanceof ApiResponseError) {
      handleApiError(err)
    }
    throw err
  }
}
